import { AgentFullData, MovieAgent } from "../entry/server/agents";
import { ApiResponse } from "../lib/api";
import { agentService } from "../services/agent-service";

export const agentRepo = {
    getMovieAgents: async (id: number): Promise<ApiResponse<MovieAgent>> => {
        return await agentService.getMovieAgents(id);
    },
    getAgents: async (type: 'directors' | 'actors', search: string, page: number): Promise<ApiResponse<AgentFullData[]>> => {
        return await agentService.getAgents(type, search, page);
    }
};